"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteEcheck = exports.saveECheck = void 0;
var axios_1 = __importDefault(require("axios"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var storage_1 = require("../../utils/storage");
/**
 * SAVE E-CHECK FORTE
 * @param token
 * @param echeck
 **/
function saveECheck(echeck, config) {
    var customerToken = config && config.token ? config.token : storage_1.getStorage('TOKEN');
    var appEnvironment = config && config.environment != null ? config.environment : storage_1.getStorage('ENVIRONMENT');
    var FORTE_PAYMENTS_URL = "https://echecks" + appEnvironment + ".cargosprintgroup.com";
    return getPaymentToken(echeck, { token: customerToken, environment: appEnvironment })
        .pipe(operators_1.switchMap(function (paymentToken) {
        return rxjs_1.from(axios_1.default({
            method: 'POST',
            url: FORTE_PAYMENTS_URL + "/forte/createPayMethod",
            data: {
                holderName: echeck.holderName,
                payMethodToken: paymentToken['onetime_token'],
            },
            headers: { Authorization: "Bearer " + customerToken },
        }));
    }));
}
exports.saveECheck = saveECheck;
/**
 * DELETE FORTE E-CHECK
 * @param token
 * @param echeck
 */
function deleteEcheck(echeck, config) {
    var customerToken = config && config.token ? config.token : storage_1.getStorage('TOKEN');
    var appEnvironment = config && config.environment != null ? config.environment : storage_1.getStorage('ENVIRONMENT');
    var FORTE_PAYMENTS_URL = "https://echecks" + appEnvironment + ".cargosprintgroup.com";
    return rxjs_1.from(axios_1.default({
        method: 'DELETE',
        url: FORTE_PAYMENTS_URL + "/forte/deletePayMethod/" + echeck.paymentToken.token,
        data: {},
        headers: { Authorization: "Bearer " + customerToken },
    })).pipe(operators_1.map(function (_a) {
        var data = _a.data;
        return data;
    }));
    ;
}
exports.deleteEcheck = deleteEcheck;
/**
 * UTILS
 **/
/**
 *
 * @param token
 * @param echeck
 *
 */
var getPaymentToken = function (echeck, config) {
    return new rxjs_1.Observable(function (observer) {
        getForteApiKey(config).subscribe(function (apiKey) {
            forte
                .createToken({
                api_login_id: apiKey.id,
                account_number: echeck.accountNumber,
                routing_number: echeck.routingNumber,
                account_type: echeck.accountType,
            })
                .success(function (forteToken) {
                observer.next(forteToken);
                observer.complete();
            })
                .error(function (error) {
                observer.error(error);
                observer.complete();
            });
        });
    });
};
/**
 *
 * @param token
 *
 */
var getForteApiKey = function (config) {
    var FORTE_PAYMENTS_URL = "https://echecks" + config.environment + ".cargosprintgroup.com";
    return rxjs_1.from(axios_1.default({
        method: 'GET',
        url: FORTE_PAYMENTS_URL + "/forte/getApiLoginId",
        headers: { Authorization: "Bearer " + config.token },
    })).pipe(operators_1.map(function (_a) {
        var data = _a.data;
        return data;
    }));
};
//# sourceMappingURL=forte.js.map